import { render, staticRenderFns } from "./BasicSettings.vue?vue&type=template&id=9710ad18&scoped=true"
import script from "./BasicSettings.vue?vue&type=script&lang=js"
export * from "./BasicSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9710ad18",
  null
  
)

export default component.exports